module.exports = __webpack_public_path__ + "img/serve_09@2x.16069ec4.png";